/************
 * Developed by : Shiva Software Solutions
 * Date : 15-06-2021
 * Descriptions : Route navigation for inner modules
 * Dependicies : To use @material-ui/core
 ************/

import {authRole} from '../shared/constants/AppConst';
// const localRoleId = localStorage.getItem('roleId');

const routesConfig = [
  {
    id: 'dashbaord',
    title: 'Dashboard',
    messageId: 'sidebar.dashboard',
    type: 'single',
    icon: 'dashboard',
    auth: authRole.dashboardRoles,
    url: '/dashboard',
  },
  {
    id: 'myDoctors',
    title: 'My Doctors',
    messageId: 'sidebar.myDoctor',
    type: 'single',
    icon: 'local_hospital',
    auth: authRole.dashboardRoles,
    url: '/myDoctors',
  },
  {
    id: 'camDashboard',
    title: 'camDashboard',
    messageId: 'sidebar.camDash',
    type: 'single',
    icon: 'camera',
    auth: authRole.camDashRoles,
    url: '/cameraDashboard',
  },
  {
    id: 'Prescriptions',
    title: 'Prescriptions',
    messageId: 'sidebar.myprescription',
    type: 'group',
    auth: authRole.dashboardRoles,
    icon: 'check_box',
    children: [
      {
        id: 'Digitized prescriptions',
        title: 'Digitized prescriptions',
        messageId: 'sidebar.digitized',
        type: 'item',
        auth: authRole.dashboardRoles,
        url: '/digitizedpres',
      },

      {
        id: 'Download Prescriptions',
        title: 'Download Prescriptions',
        messageId: 'sidebar.download',
        type: 'item',
        url: '/downloadPrescription',
      },
    ],
  },
  {
    id: 'searchpatientphar',
    title: 'searchpatientphar',
    messageId: 'sidebar.searchPat',
    type: 'single',
    icon: 'manage_search',
    auth: authRole.pharmacyRoles,
    url: '/pharmacy',
    count: '0',
    color: '#ff0000',
  },
  {
    id: 'searchpatientphar',
    title: 'searchpatientphar',
    messageId: 'sidebar.searchPat',
    type: 'single',
    icon: 'manage_search',
    auth: authRole.pharmacyRoles,
    url: '/sarvodhayaPharmacy',
    count: '0',
    color: '#ff0000',
  },
  {
    id: 'dispensedList',
    title: 'dispensedList',
    messageId: 'sidebar.disList',
    type: 'single',
    icon: 'domain_verification',
    auth: authRole.pharmacyRoles,
    url: '/pharmacydispenced',
    count: '0',
    color: '#ff0000',
  },
  {
    id: 'dispensedList',
    title: 'dispensedList',
    messageId: 'sidebar.disList',
    type: 'single',
    icon: 'domain_verification',
    auth: authRole.pharmacyRoles,
    url: '/sarvopharmacydispenced',
    count: '0',
    color: '#41DC8E',
  },
  {
    id: 'callBackList',
    title: 'callBackList',
    messageId: 'sidebar.pharmacyCallBackList',
    type: 'single',
    icon: 'phone_missed',
    auth: authRole.pharmacyRoles,
    url: '/pharmacyCallBackList',
  },
  {
    id: 'itadmin',
    title: 'itadmin',
    messageId: 'sidebar.itadmin',
    type: 'single',
    icon: 'document_scanner',
    auth: authRole.itAdminRoles,
    url: '/ITAdminpage',
  },
  {
    id: 'searchpatientlab',
    title: 'searchpatientlab',
    messageId: 'sidebar.searchTest',
    type: 'single',
    icon: 'manage_search',
    auth: authRole.labRoles,
    url: '/labAssist',
    count: '0',
    color: '#ff0000',
  },
  {
    id: 'completedListlab',
    title: 'completedListlab',
    messageId: 'sidebar.compTest',
    type: 'single',
    icon: 'domain_verification',
    auth: authRole.labRoles,
    url: '/labAssistComplete',
    count: '0',
    color: '#41DC8E',
  },
  {
    id: 'searchpatient',
    title: 'searchpatient',
    messageId: 'sidebar.searchTest',
    type: 'single',
    icon: 'manage_search',
    auth: authRole.radiologyRoles,
    url: '/radioAssist',
    count: '0',
    color: '#ff0000',
  },
  {
    id: 'completedListrad',
    title: 'completedListrad',
    messageId: 'sidebar.compTest',
    type: 'single',
    icon: 'domain_verification',
    auth: authRole.radiologyRoles,
    url: '/radioAssistComplete',
    count: '0',
    color: '#41DC8E',
  },
  {
    id: 'pendingRequest',
    title: 'pendingRequest',
    messageId: 'sidebar.pendReq',
    type: 'single',
    icon: 'manage_search',
    auth: authRole.itadminRoles,
    url: '/ITAdminpage',
  },
  {
    id: 'completedList',
    title: 'completedList',
    messageId: 'sidebar.comReq',
    type: 'single',
    icon: 'domain_verification',
    auth: authRole.itadminRoles,
    url: '/ITAdminCompleted',
  },
  {
    id: 'dischargeCell',
    title: 'dischargeCell',
    messageId: 'sidebar.disCell',
    type: 'single',
    icon: 'auto_mode',
    auth: authRole.MTRoles,
    url: '/dischargeCell',
    children: [{url: '/dischargeCell'}, {url: '/dischargecellProcess'}],
  },
  {
    id: 'dischargeCell',
    title: 'dischargeCell',
    messageId: 'sidebar.disCell',
    type: 'single',
    icon: 'auto_mode',
    url: '/dischargecellProcess',
    auth: authRole.MTRoles,
    hide: true,
  },
  {
    id: 'Reports',
    title: 'Reports',
    messageId: 'sidebar.reports',
    type: 'group',
    auth: authRole.pharmacyRoles,
    icon: 'receipt_long',
    children: [
      {
        id: 'newmedicine',
        title: 'newmedicine',
        messageId: 'sidebar.newmedicine',
        type: 'item',
        url: '/newMedicine',
        auth: authRole.userPhar,
      },
      {
        id: 'alternativemedicine',
        title: 'alternativemedicine',
        messageId: 'sidebar.alternativemedicine',
        type: 'item',
        url: '/alernativeMedicine',
        auth: authRole.userPhar,
      },
      {
        id: 'missedmedicine',
        title: 'missedmedicine',
        messageId: 'sidebar.missedmedicine',
        type: 'item',
        url: '/missedMedicine',
        auth: authRole.userPhar,
      }
    ]
  }
];
export default routesConfig;
